// Keep native, keyboard-accessible navigation and Shopify cart behavior.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const menu = document.querySelector('.casa-mobile-menu');
  if (!menu?.open) return;
  if (event.target.closest('.casa-mobile-menu nav a') || !menu.contains(event.target)) menu.open = false;
}, { capture: true });
window.addEventListener('hashchange', () => {
  const menu = document.querySelector('.casa-mobile-menu');
  if (menu) menu.open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.casa-mobile-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
});
